import { ArrowNavRightIcon } from "@bookingcom/bui-assets-react/streamline";
import { Actionable, Card, HiddenVisually, Icon, ListItem, Text } from "@bookingcom/bui-react";
import React from "react";
import { useDSABannerController } from "./useDSABanner.controller.js";
const id = "dsa_label_descr";
const DSABannerDesktop = () => {
    const view = useDSABannerController();
    if (!view.shouldRender) {
        return undefined;
    }
    return (React.createElement(Actionable, { wide: true, href: view.linkUrl, attributes: {
            style: { display: "block" },
            target: "_blank",
            "data-testid": "DSABanner_link",
            "aria-describedby": id
        } },
        React.createElement(Card, { fill: true },
            React.createElement(ListItem, { onClick: () => { }, endSlot: React.createElement(Icon, { svg: ArrowNavRightIcon, size: "medium" }) },
                React.createElement(Text, null, view.message)),
            React.createElement(HiddenVisually, null,
                React.createElement("div", { id: id }, view.linkLabel)))));
};
export default DSABannerDesktop;
